import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import axios from "axios";

import { Button, Modal, CardContent } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';

import i18n from "locales/i18n";
import MainCard from "components/MainCard";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals';
import { customFileAxios } from "components/axios/customAxios";

const MasterSpecExcelUploadLayer = ({ specKeyList }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const [excelFile, setExcelFile] = useState();
    const [fileLoading, setFileLoading] = useState(false);

    const { handleSubmit} = useForm({});
    
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose: () => { },
            message: alertMessage,
        });
    };

    const handleExelUpload = (data, e) => {
        e.preventDefault();
        setFileLoading(true);

        if (!excelFile) {
            handleAlertClick(t('message.common.alert.excel.file.write'));
            setFileLoading(false);
            return;
        }

        let formData = new FormData();
        formData.append("file", excelFile);

        try {
            openModal(modals.confirmModal, {
                onSubmit : (value) => {
                    try {
                        const res = customFileAxios.post(`/api/specKeys/excel`, formData).then((res)=>{
                            handleAlertClick(t('message.common.alert.write.done'));
                            setFileLoading(false);
                            setOpen(false);
                            specKeyList(0);
                        }).catch((err)=>{
                            console.log(err);
                            setFileLoading(false);
                            handleAlertClick(err.response?.data?.message || err.message);
                        });
                        // return res.data;
                    } catch (error) {
                        console.error("error :", error);
                        throw error;
                    }
                },
                onClose : () => {
                    setFileLoading(false);
                },
                message: t('message.common.alert.write.question'),
            });
        } catch(error) {
            console.log(error);
            setFileLoading(false);
        }
    };

    const sampleDownload = () => {
        if(i18n.language === 'ko') {
            window.location.href = '/SpecKey_sample.xlsx';
        } else if (i18n.language === 'zh') {
            window.location.href = '/SpecKey_sample-zh.xlsx';
        }
    }

    return (
        <>
            <Button variant="contained" color='success' onClick={() => setOpen(true)}>
                Excel {t('message.common.chip.spec')} {t('message.common.btn.write')}
            </Button>

            <Modal className="pop_box" open={open} onClose={() => setOpen(false)}>
                <MainCard title={`Excel ${t('message.common.chip.spec')} ${t('message.common.btn.write')}`} modal darkTitle content={false} style={{ width: "900px" }}>
                    <div style={{ marginTop: "-40px", marginRight: "12px", textAlign: "right" }}>
                        <Button variant="contained" color="primary" size="small" onClick={() => setOpen(false)}>
                            {t('message.common.btn.close')}
                        </Button>
                    </div>
                    <CardContent>
                        <form onSubmit={handleSubmit(handleExelUpload)}>
                            <div className='modal_imagelayer_img modal_imagelayer_img1'>
                                <div style={{width:"unset"}}>
                                    <span>Excel</span>
                                    <div style={{display:"flex", justifyContent: "space-between"}}>
                                        <div>
                                            <input
                                                type="file" 
                                                accept=".xlsx" 
                                                onChange={(e)=>{
                                                    setExcelFile(e.target.files[0]);
                                                }}
                                            />
                                        </div>
                                        <div style={{cursor:"pointer"}} onClick={() => {sampleDownload()}}>
                                            Excel Sample File<ArchiveOutlinedIcon fontSize="small" ></ArchiveOutlinedIcon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{"marginTop": "10px",display: "flex","justifyContent": "flex-start", alignItems:"center", color:"#000"}}>
                                <LoadingButton variant="contained" color="info" loading={fileLoading} onClick={handleSubmit(handleExelUpload)}>{t('message.common.btn.write')}</LoadingButton>
                                <span style={{marginLeft:"5px", color: "#fff"}}>* {t('message.common.guide.download.excel.instruction')}</span>
                            </div>
                        </form>
                    </CardContent>
                </MainCard>
            </Modal>
        </>
    );
};

export default MasterSpecExcelUploadLayer;
